import React from 'react';

import isObject from 'lodash/isObject';

import {
  Log,
  Logs,
  LogText,
  LogComment,
  LogChanges,
  LogChangedValue,
} from '@gogame/components';

import { getColor } from '../Status';
import AdditionalSpendFee from './AdditionalSpendFee';

const ADDED = 1;
const REMOVED = 2;
const UPDATED = 3;

function isAdditionalSpendFee(value) {
  return (
    isObject(value) &&
    value.hasOwnProperty('taxFeePercent') &&
    value.hasOwnProperty('period')
  );
}

const TYPE_MAP = {
  [ADDED]: 'add',
  [REMOVED]: 'remove',
  [UPDATED]: 'change',
};

const ActionsLog = ({ logs = [] }) => {
  return (
    <Logs empty={!logs.length}>
      {logs.map((log, id) => {
        return (
          <Log key={id} color={getColor(log.status?.id)}>
            <LogText
              action={log.actionType?.name}
              user={log.changedBy}
              date={log.changedDate}
              status={log.status?.name}
            >
              {log.comment && <LogComment>{log.comment}</LogComment>}
              {log.details?.map((change) => {
                const additionalSpendFee = isAdditionalSpendFee(change.value);
                let valueC;

                if (additionalSpendFee) {
                  valueC = (
                    <LogChangedValue
                      value={<AdditionalSpendFee {...change.value} />}
                      newValue={
                        change.newValue ? (
                          <AdditionalSpendFee {...change.newValue} />
                        ) : undefined
                      }
                    />
                  );
                } else {
                  valueC = (
                    <LogChangedValue
                      value={change.value}
                      newValue={change.newValue}
                    />
                  );
                }

                return (
                  <LogChanges
                    label={change.field}
                    type={TYPE_MAP[change.changeType]}
                  >
                    {valueC}
                  </LogChanges>
                );
              })}
            </LogText>
          </Log>
        );
      })}
    </Logs>
  );
};

export default ActionsLog;
